import { SharedSettings } from '../projects/shared/src/lib/models/shared-settings';

export const environment: SharedSettings & {
    ids: { [key: string]: string };
} = {
    isProduction: true,
    buildNumber: '20260804.2',

    appInsightsKey: '57a7df23-0df2-4dd2-82db-fd62fdd6d074',

    authAuthority: 'https://login.microsoftonline.com/80b522f3-5ca0-44ab-88f7-03366fc716bb/',
    authClientId: '5a6b52f1-096a-491b-a288-a823acc62aa9',
    authScopes: ['api://c10a6246-5a5d-4545-a415-e13059260101/api_access', 'email', 'profile'],

    apiBaseUrl: 'https://propak-vision-services-inventory-prod.azurewebsites.net/api/',
    hubsBaseUrl: 'https://propak-vision-services-inventory-prod.azurewebsites.net/hubs/',

    validAccountDomains: ['propak.com', 'plasolutions.com', 'plofa.com', 'plofa.onmicrosoft.com'],

    ids: {
        ChepCustomerAccountNumber: 'CHEP001',
        ChepShippingAccountNumber: 'CHEPSHIP',
        PimsReportName: 'Comparison PIMS',
        TowerReportName: 'Comparison Tower',
        MaterialsReportName: 'Comparison Chep Materials',
    },

    features: {
        navinvoicetrigger: true
    },

    fallbackTimeZone: 'America/Chicago',

    oidenBaseUrl: 'https://oiden-prod-vb12la.azurewebsites.net'
};
